import { render, staticRenderFns } from "./DocumentViewer.vue?vue&type=template&id=d3a390a4&scoped=true&"
import script from "./DocumentViewer.vue?vue&type=script&lang=ts&"
export * from "./DocumentViewer.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentViewer.vue?vue&type=style&index=0&id=d3a390a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a390a4",
  null
  
)

export default component.exports